import { render, staticRenderFns } from "./ConfirmReturnSelection.vue?vue&type=template&id=4d016679&scoped=true"
import script from "./ConfirmReturnSelection.vue?vue&type=script&lang=js"
export * from "./ConfirmReturnSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d016679",
  null
  
)

export default component.exports